'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
	(function (StoryPage, $) {
		var $dom = {};

		var cacheDom = function cacheDom() {
			$dom.statisticsTrigger = $('[data-statistics-trigger]');
			$dom.statisticsContainer = $('[data-statistics]');

			$dom.resultsType = $('[data-result-type]');
			$dom.resultsImages = $('[data-result-images]');

			$dom.storyMenuTrigger = $('[data-story-menu-trigger]');

			$dom.Ingredient = $('[data-how-ingredient]');

			// founder's letter scroll animation elements
			$dom.FoundersWrapper = $('#js-founders-wrapper');
			$dom.HeadlineElement = $('#js-why-headline');

			// On mobile, will need to toggle how much of the letter is shown.
			$dom.FounderExpandTrigger = $('#js-mobile-expander');
			$dom.FounderLetter = $('#js-founder-letter-content');
		};

		var customFunctions = function customFunctions() {
			$('.results__images.active').addClass('is-animate');

			$('.results__images.active').click(function () {
				$('.results__images.active').removeClass('is-animate');
			});

			var skinBarBack;

			function skinBarBackStart() {
				skinBarBack = setTimeout(function () {
					$('.c-skinSliderImage__before').removeClass('is-drag');
					$('.c-skinSliderImage__after').removeClass('is-drag');
					$('.c-skinSliderImage__resizeImg').removeAttr("style");
					$('.c-skinSlider__bar').removeAttr("style");
				}, 3000);
			}

			function skinBarBackStop() {
				clearTimeout(skinBarBack);
			}

			$('.c-skinSliderImage__before').click(function () {
				skinBarBackStop();
				$(this).toggleClass('is-drag');
				if ($(this).hasClass("is-drag")) {
					$(this).parents('.c-skinSliderImage').find('.c-skinSliderImage__resizeImg').css('width', '94.4444%');
					$(this).parents('.c-skinSliderImage').find('.c-skinSlider__bar').css('left', '94.4444%');
					skinBarBackStart();
				} else {
					$('.c-skinSliderImage__resizeImg').removeAttr("style");
					$('.c-skinSlider__bar').removeAttr("style");
				}
			});

			$('.c-skinSliderImage__after').click(function () {
				skinBarBackStop();
				$(this).toggleClass('is-drag');
				if ($(this).hasClass("is-drag")) {
					$(this).parents('.c-skinSliderImage').find('.c-skinSliderImage__resizeImg').css('width', '5.55556%');
					$(this).parents('.c-skinSliderImage').find('.c-skinSlider__bar').css('left', '5.55556%');
					skinBarBackStart();
				} else {
					$('.c-skinSliderImage__resizeImg').removeAttr("style");
					$('.c-skinSlider__bar').removeAttr("style");
				}
			});

			$(document).on("mouseover touchend", '.results__images.active', function () {
				$('.results__images.active').removeClass('is-animate');
			});

			$(document).on("mouseleave", '.c-skinSliderImage__main', function () {
				skinBarBackStop();
				skinBarBackStart();
			});

			$(document).on("mouseup touchend", '.c-skinSlider__bar', function () {
				skinBarBackStop();
				if (!$(this).hasClass("draggable")) {
					if ($(this).css('left')) {
						skinBarBackStart();
					}
				}
			});
		};

		var ToggleMenu = function ToggleMenu(state) {
			if (state == 'show') {
				$dom.storyMenu.addClass('active').fadeIn(500);
			} else {
				$dom.storyMenu.removeClass('active').fadeOut(500);
			}
		};

		var bindUIActions = function bindUIActions() {
			$dom.statisticsTrigger.on('click', function () {
				if (!$dom.statisticsContainer.hasClass('active')) {
					$dom.statisticsContainer.addClass('active').slideDown(500);
				} else {
					$dom.statisticsContainer.removeClass('active').slideUp(500);
				}
			});

			$(document).on('click', '[data-result-type]', function () {
				if (!$(this).hasClass('active')) {
					$dom.resultsType.removeClass('active');
					$(this).addClass('active');
					var resultType = $(this).attr('data-handle');
					$dom.resultsImages.removeClass('active');
					$('[data-result-images][data-handle="' + resultType + '"]').addClass('active');
				}
			});

			$dom.storyMenuTrigger.on('click', function () {
				if (!$(this).next('[data-story-menu]').hasClass('active')) {
					$(this).next('[data-story-menu]').addClass('active').fadeIn(500);
					$(this).addClass('active');
				} else {
					$(this).next('[data-story-menu]').removeClass('active').fadeOut(500);
					$(this).removeClass('active');
				}
			});

			$dom.Ingredient.on('click', function () {
				if ($(window).width() < 992) {
					if (!$(this).hasClass('active')) {
						$dom.Ingredient.removeClass('active').find('.ingredients__item-details').slideUp(500);
						$(this).addClass('active').find('.ingredients__item-details').slideDown(500);
					} else {
						$(this).removeClass('active').find('.ingredients__item-details').slideUp(500);
					}
				}
			});

			if ($dom.FoundersWrapper.length) {
				$(document).on('scroll', function (event) {
					performScrollCalculations();
				});

				$(document).ready(function (event) {
					setupLetterGradient();
					performScrollCalculations();
				});
			}

			$dom.FounderExpandTrigger.on('click', function (event) {
				// Need the natural height of the content (for adding smooth expand animation)
				var naturalHeight = $("#js-founder-letter-content")[0].scrollHeight;
				$dom.FounderLetter.css("maxHeight", naturalHeight + 'px');
				// remove our classes for collapsing the letter
				$dom.FounderLetter.removeClass("mobile-collapsed");
				$dom.FounderExpandTrigger.hide();
				// set a timeout for removing the max height (for if window is resized)
				setTimeout(function () {
					$dom.FounderLetter.css("maxHeight", "");
				}, 500);
			});

			$('[data-result-tab] div:first-child').addClass('is-active');
			$('.c-storyReportContent .c-storyReportContent__box:first-child').addClass('is-active');

			function dataTab() {
				if ($(window).width() < 1023) {
					$('.c-storyReportTab__mobile').removeClass('is-active');
					$('.c-storyReportTab__row').slideUp();
					$('.c-storyReportContent__box').removeClass('is-tab-open');
				}
			}

			$('[data-result-tab] div').click(function () {
				var tab_id = $(this).attr('data-tab');
				var tab_copy = $(this).text();
				$('.c-storyReportTab__mobile span').text(tab_copy);
				$('[data-result-tab] div').removeClass('is-active');
				$('.c-storyReportContent__box').removeClass('is-active');
				$(this).addClass('is-active');
				$(this).closest('.c-storyReport').find("#" + tab_id).addClass('is-active');

				dataTab();
			});

			$('.c-storyReportTab__mobile').click(function () {
				$(this).toggleClass('is-active');
				$('.c-storyReportTab__row').slideToggle();
				$('.c-storyReportContent__box').toggleClass('is-tab-open');
			});
		};

		// Set the max height of the letter for mobile sizes
		var setupLetterGradient = function setupLetterGradient() {
			var numberLines = $dom.FounderLetter.data("linesVisible");
			var lineHeight = parseInt($dom.FounderLetter.css("lineHeight"), 10);
			var maxHeight = numberLines * lineHeight;
			$dom.FounderLetter.css("maxHeight", maxHeight + 'px');
			$dom.FounderLetter.css("paddintTop", '50%');
		};

		// Set's the letter positioning based on the scroll position of the page
		var performScrollCalculations = function performScrollCalculations() {
			// First, need the position of wrapper to compare against the window
			var offset = $dom.FoundersWrapper.offset();
			var scrollPos = $(document).scrollTop();
			var height = $(window).height();
			var basePadding = $dom.FoundersWrapper.data("basePadding");
			var distanceAboveScreen = height + scrollPos - offset.top;
			var baseColor = $dom.FoundersWrapper.data("baseColor");
			// If we're that far above the letter, don't bother animating
			if (distanceAboveScreen < 0) {
				return;
			}
			// Need to check how far above the bottom of the screen the letter is
			// (how much to reduce padding by)
			var percentAboveScreen = (distanceAboveScreen + 5) * 100 / height;
			var newPadding = basePadding - percentAboveScreen;
			var marginTop = percentAboveScreen * 2;
			// If we're high enough up, set a class to change background color
			if (percentAboveScreen > basePadding) {
				$dom.FoundersWrapper.addClass("clean-background");
				$dom.HeadlineElement.addClass("clean-background");
			} else {
				$dom.FoundersWrapper.removeClass("clean-background");
				$dom.HeadlineElement.removeClass("clean-background");
			}
			// if we've fully scrolled to the founders letter, don't overcompensate margin/padding
			if (percentAboveScreen > 100) {
				return;
			}
			$dom.FoundersWrapper.css("marginTop", '-' + marginTop + 'px');
			$dom.FoundersWrapper.css("paddingTop", newPadding + '%');
		};

		StoryPage.init = function () {
			cacheDom();
			customFunctions();
			bindUIActions();
			$(window).resize(function () {
				$('.c-storyReportTab__row').removeAttr('style');
				$('.c-storyReportContent__box').removeClass('is-tab-open');
			});
		};
	})(window.StoryPage = window.StoryPage || {}, _jquery2.default, undefined);
};